// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-button-component-container {
  border: 1px solid #D3E1ED;
  border-radius: 45px;
  font-size: 14px;
  font-weight: 700;
  min-width: 70px;
  box-sizing: border-box;
  height: 35px;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.toggle-button-component-container .toggle-button-option-on {
  color: white;
  border-radius: 45px;
  background-color: #40A0C1;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
}
.toggle-button-component-container .toggle-button-option-off {
  color: black;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/ToggleButton/ToggleButton.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AACD;AACC;EACC,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACF;AAEC;EACC,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAAF","sourcesContent":[".toggle-button-component-container {\n\tborder: 1px solid #D3E1ED;\n\tborder-radius: 45px;\n\tfont-size: 14px;\n\tfont-weight: 700;\n\tmin-width: 70px;\n\tbox-sizing: border-box;\n\theight: 35px;\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tuser-select: none;\n\n\t.toggle-button-option-on {\n\t\tcolor: white;\n\t\tborder-radius: 45px;\n\t\tbackground-color: #40A0C1;\n\t\theight: 35px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 50px;\n\t}\n\n\t.toggle-button-option-off {\n\t\tcolor: black;\n\t\theight: 35px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 50px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
